/**
 * Strips markdown formatting from text
 * @param {string} text - The text containing markdown
 * @returns {string} - Plain text without markdown formatting
 */
export const stripMarkdown = (text) => {
  if (!text) return "";

  return (
    text
      // Remove bold/italic
      .replace(/\*\*(.*?)\*\*/g, "$1")
      .replace(/__(.*?)__/g, "$1")
      .replace(/\*(.*?)\*/g, "$1")
      .replace(/_(.*?)_/g, "$1")
      // Remove code blocks
      .replace(/```[\s\S]*?```/g, "")
      .replace(/`(.*?)`/g, "$1")
      // Remove links but keep text
      .replace(/\[(.*?)\]\(.*?\)/g, "$1")
      // Remove headers
      .replace(/#{1,6}\s+(.*)/g, "$1")
      // Remove blockquotes
      .replace(/>\s+(.*)/g, "$1")
      // Remove horizontal rules
      .replace(/---/g, "")
      // Remove HTML tags
      .replace(/<[^>]*>/g, "")
  );
};

/**
 * Truncates text to a specified length and adds ellipsis
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length before truncation
 * @returns {string} - Truncated text with ellipsis if needed
 */
export const truncateText = (text, maxLength = 50) => {
  if (!text) return "";

  const plainText = stripMarkdown(text);

  if (plainText.length <= maxLength) return plainText;

  return plainText.substring(0, maxLength) + "...";
};

/**
 * Removes everything after (and excluding) the given question marker.
 * Keeps the marker itself.
 *
 * @param {string} text - The full markdown/text
 * @param {number|string} questionNumber - The question number to truncate at (default: 11)
 * @returns {string} - Text up through the specified "Question X" line
 */
export const removeAfterQuestion = (text, questionNumber = 11) => {
  // Build a regex that matches "Question 11" plus all following characters
  const re = new RegExp(`(Question ${questionNumber})[\\s\\S]*`);
  // Replace the match with just the marker (first capture group)
  return text.replace(re, "$1");
};
